import { render } from "./BasicModal.vue?vue&type=template&id=50ac56a2&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"

import "./BasicModal.vue?vue&type=style&index=0&id=50ac56a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50ac56a2"

export default script